import React from "react";
import { Logo } from "./Logo";

const Loading = () => {
  return (
    <div className="loading">
      <Logo className="logo-splash" />
      <h1>Loading...</h1>
    </div>
  );
};

export default Loading;
